<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<link href="styles/default.css" rel="stylesheet" type="text/css"/>
<title>Aunt Bee’s Delightful Desserts: More Than 350 Recipes from Mayberry, Americas’s Friendliest Town</title>
<p class="ctr" id="pAjmp"><a href="#/contents#RR_16" id="CC_16"> Hot Plate Hot Chocolate</a></p>
<p class="tx6" id="pASa5"><i> Folks will come knocking on your door for it. </i></p>
<p class="tx5" id="pAQ2"><b> 1 8-quart box nonfat dry milk </b></p>
<p class="tx5" id="Aup8"><b> 1 pound confectioners’ sugar </b></p>
<p class="tx5" id="A-Zq"><b> 11 ounces coffee creamer </b></p>
<p class="tx5" id="pAdEq"><b> 2 pounds Nestle’s Quik </b></p>
<p class="tx5" id="A30Z"><b> 2 teaspoons cinnamon, optional </b></p>
<p class="tx1" id="pA4_v"><span class="dcap">M</span>ix all ingredients. Use ¼ cup mixture to 1 serving cup hot water. Stir.</p>
<p class="txrr" id="pAqXR"> <i>Gary Wedemeyer—Fall Branch, Tennessee</i></p>
<div class="box" id="AhU">
<p class="tx1a" id="pAfr"><i>Barney gets a little sugar from Thelma Lou:</i></p>
<table id="pAxM">
<tbody id="AxM" style="vertical-align: top;">
<tr id="tr-AxM-0">
<td id="td-AxM-0-0" style="width: 25%;"><p class="txtb">THELMA LOU:</p></td>
<td id="td-AxM-0-1">Barney, I brought you something I think you can handle even while you’re wearing that thing.</td>
</tr>
<tr id="tr-AxM-1">
<td colspan="2" id="td-AxM-1-0">(She hands him a huge milkshake.)</td>
</tr>
<tr id="tr-AxM-2">
<td id="td-AxM-2-0"><p class="txtb">BARNEY:</p></td>
<td id="td-AxM-2-1">Hey, with a straw. I never thought of that. What is it?</td>
</tr>
<tr id="tr-AxM-3">
<td id="td-AxM-3-0"><p class="txtb">THELMA LOU:</p></td>
<td id="td-AxM-3-1">Double-rich vanilla with two raw eggs.</td>
</tr>
<tr id="tr-AxM-4">
<td id="td-AxM-4-0"><p class="txtb">BARNEY:</p></td>
<td id="td-AxM-4-1">Boy, that’s thick.</td>
</tr>
<tr id="tr-AxM-5"><td colspan="2" id="td-AxM-5-0">(He stretches for it.)</td>
</tr>
<tr id="tr-AxM-6">
<td id="td-AxM-6-0"><p class="txtb">THELMA LOU:</p></td>
<td id="td-AxM-6-1">Oh, I’m sorry.</td>
</tr>
<tr id="tr-AxM-7">
<td id="td-AxM-7-0"><p class="txtb">BARNEY:</p></td>
<td id="td-AxM-7-1">Oh, that’s all right. It’s good practice for puckering, if you know what I mean.</td>
</tr>
</tbody>
</table></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter16.vue?35ba7c38